module.exports = __webpack_public_path__ + "img/lit_main_logo_2.a489e3f5.png";